import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  pages: {
    pageNo: 1,
    totalPages: 1,
    pageSize: 10,
    totalElements: 0
  }
};

const EnachSlice = createSlice({
  name: 'enachSlice',
  initialState,
  reducers: {
    setUploadHistory(state, action) {
      const response = action.payload;
      const historyData =
        response?.data?.map(item => ({
          fileName: item?.metadata?.uploadedFileName,
          createdAtEpochMillis: item?.createdAtEpochMillis,
          status: item?.status,
          totalLans: item?.metadata?.totalLans,
          referenceId: item?.referenceId
        })) || [];

      state.pages = response?.pages;
      state.data = historyData;
    }
  }
});

export const { setUploadHistory } = EnachSlice.actions;

export default EnachSlice.reducer;
